import { ArrowDownIcon, CalendarIcon } from '@src/shared/ui/icons';
import { DateInputOld, InputAdornment } from '@src/shared/ui/inputs';

import { type ComponentRef, forwardRef, useState } from 'react';
import StyleSheet from '../styles';
import CalendarHeader from './CalendarHeader';

interface DayPickerProps {
  value?: Date;
  onChange?: (date: Date | null) => void;
}
type DateFieldRef = ComponentRef<typeof DateInputOld>;
const DayPicker = forwardRef<DateFieldRef, DayPickerProps>((props, ref) => {
  const [open, setOpen] = useState(false);

  const { onChange, ...rest } = props;
  const handleChange = (newValue: Date | null) => {
    onChange?.(newValue);
  };
  return (
    <DateInputOld
      ref={ref}
      {...rest}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={handleChange}
      views={['day']}
      format="MMMM dd, yyyy"
      slots={{
        openPickerIcon: ArrowDownIcon,
        calendarHeader: CalendarHeader,
      }}
      slotProps={{
        textField: {
          margin: 'none',
          readOnly: true,
          onClick: () => setOpen(true),
          InputProps: {
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">
                <CalendarIcon />
              </InputAdornment>
            ),
            sx: { cursor: 'pointer', '& input': { cursor: 'pointer' } },
          },
        },
      }}
      sx={StyleSheet.datePicker}
    />
  );
});
export default DayPicker;
